function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe"
    )
  );
}

document.querySelectorAll('[id^="Details-"] summary').forEach((summary) => {
  summary.setAttribute('role', 'button');
  summary.setAttribute('aria-expanded', summary.parentNode.hasAttribute('open'));

  if (summary.nextElementSibling.getAttribute('id')) {
    summary.setAttribute('aria-controls', summary.nextElementSibling.id);
  }

  summary.addEventListener('click', (event) => {
    event.currentTarget.setAttribute('aria-expanded', !event.currentTarget.closest('details').hasAttribute('open'));
  });

  if (summary.closest('header-drawer, menu-drawer')) return;
  summary.parentElement.addEventListener('keyup', onKeyUpEscape);
});

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);
  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (event.target !== container && event.target !== last && event.target !== first) return;

    document.addEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener('keydown', trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if ((event.target === container || event.target === first) && event.shiftKey) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener('focusout', trapFocusHandlers.focusout);
  document.addEventListener('focusin', trapFocusHandlers.focusin);

  elementToFocus.focus();

  if (
    elementToFocus.tagName === 'INPUT' &&
    ['search', 'text', 'email', 'url'].includes(elementToFocus.type) &&
    elementToFocus.value
  ) {
    elementToFocus.setSelectionRange(0, elementToFocus.value.length);
  }
}

// Here run the querySelector to figure out if the browser supports :focus-visible or not and run code based on it.
try {
  document.querySelector(':focus-visible');
} catch (e) {
  focusVisiblePolyfill();
}

function focusVisiblePolyfill() {
  const navKeys = [
    'ARROWUP',
    'ARROWDOWN',
    'ARROWLEFT',
    'ARROWRIGHT',
    'TAB',
    'ENTER',
    'SPACE',
    'ESCAPE',
    'HOME',
    'END',
    'PAGEUP',
    'PAGEDOWN',
  ];
  let currentFocusedElement = null;
  let mouseClick = null;

  window.addEventListener('keydown', (event) => {
    if (navKeys.includes(event.code.toUpperCase())) {
      mouseClick = false;
    }
  });

  window.addEventListener('mousedown', (event) => {
    mouseClick = true;
  });

  window.addEventListener(
    'focus',
    () => {
      if (currentFocusedElement) currentFocusedElement.classList.remove('focused');

      if (mouseClick) return;

      currentFocusedElement = document.activeElement;
      currentFocusedElement.classList.add('focused');
    },
    true
  );
}

function pauseAllMedia() {
  document.querySelectorAll('.js-youtube').forEach((video) => {
    video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
  });
  document.querySelectorAll('.js-vimeo').forEach((video) => {
    video.contentWindow.postMessage('{"method":"pause"}', '*');
  });
  document.querySelectorAll('video').forEach((video) => {
    if (!video.paused) video.dataset.autoPaused = 'true';
    video.pause();
  });
  document.querySelectorAll('product-model').forEach((model) => {
    if (model.modelViewerUI) model.modelViewerUI.pause();
  });
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener('focusin', trapFocusHandlers.focusin);
  document.removeEventListener('focusout', trapFocusHandlers.focusout);
  document.removeEventListener('keydown', trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

function onKeyUpEscape(event) {
  if (event.code.toUpperCase() !== 'ESCAPE') return;

  const openDetailsElement = event.target.closest('details[open]');
  if (!openDetailsElement) return;

  const summaryElement = openDetailsElement.querySelector('summary');
  openDetailsElement.removeAttribute('open');
  summaryElement.setAttribute('aria-expanded', false);
  summaryElement.focus();
}

class QuantityInput extends HTMLElement {
  constructor() {
    super();

    this.input = this.querySelector('input');

    this.changeEvent = new Event('change', { bubbles: true });

    this.input.addEventListener('change', this.onInputChange.bind(this));

    this.querySelectorAll('button').forEach((button) =>
      button.addEventListener('click', this.onButtonClick.bind(this))
    );
  }

  quantityUpdateUnsubscriber = undefined;

  connectedCallback() {
    this.validateQtyRules();

    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }

  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) {
      this.quantityUpdateUnsubscriber();
    }
  }

  onInputChange(event) {
    this.validateQtyRules();
  }

  onButtonClick(event) {
    event.preventDefault();

    const previousValue = this.input.value;

    const targetButton = event.target.closest('.quantity__button');

    if (!targetButton) return;

    if (targetButton.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else {
      this.input.stepDown();
    }

    if (previousValue !== this.input.value) this.input.dispatchEvent(this.changeEvent);

    if (this.input.dataset.min === previousValue && targetButton.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }

  validateQtyRules() {
    const value = parseInt(this.input.value);

    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");

      buttonMinus.classList.toggle('disabled', parseInt(value) <= parseInt(this.input.min));
    }

    if (this.input.max) {
      const max = parseInt(this.input.max);

      const buttonPlus = this.querySelector(".quantity__button[name='plus']");

      buttonPlus.classList.toggle('disabled', value >= max);
    }
  }
}

customElements.define('quantity-input', QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: `application/${type}` },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == 'undefined') {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent('on' + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options['method'] || 'post';
  var params = options['parameters'] || {};

  var form = document.createElement('form');
  form.setAttribute('method', method);
  form.setAttribute('action', path);

  for (var key in params) {
    var hiddenField = document.createElement('input');
    hiddenField.setAttribute('type', 'hidden');
    hiddenField.setAttribute('name', key);
    hiddenField.setAttribute('value', params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (country_domid, province_domid, options) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

  Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler, this));

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute('data-default');
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute('data-default');
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute('data-provinces');
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = 'none';
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement('option');
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = '';
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement('option');
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class MenuDrawer extends HTMLElement {
  constructor() {
    super();

    this.mainDetailsToggle = this.querySelector('details');

    this.addEventListener('keyup', this.onKeyUp.bind(this));
    this.addEventListener('focusout', this.onFocusOut.bind(this));
    this.bindEvents();
  }

  bindEvents() {
    this.querySelectorAll('summary').forEach((summary) =>
      summary.addEventListener('click', this.onSummaryClick.bind(this))
    );
    this.querySelectorAll(
      'button:not(.localization-selector):not(.country-selector__close-button):not(.country-filter__reset-button)'
    ).forEach((button) => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
  }

  onKeyUp(event) {
    if (event.code.toUpperCase() !== 'ESCAPE') return;

    const openDetailsElement = event.target.closest('details[open]');
    if (!openDetailsElement) return;

    openDetailsElement === this.mainDetailsToggle
      ? this.closeMenuDrawer(event, this.mainDetailsToggle.querySelector('summary'))
      : this.closeSubmenu(openDetailsElement);
  }

  onSummaryClick(event) {
    const summaryElement = event.currentTarget;
    const detailsElement = summaryElement.parentNode;
    const parentMenuElement = detailsElement.closest('.has-submenu');
    const isOpen = detailsElement.hasAttribute('open');
    const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    if (detailsElement === this.mainDetailsToggle) {
      if (isOpen) event.preventDefault();
      isOpen ? this.closeMenuDrawer(event, summaryElement) : this.openMenuDrawer(summaryElement);

      if (window.matchMedia('(max-width: 990px)')) {
        document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
      }
    } else {
      setTimeout(() => {
        detailsElement.classList.add('menu-opening');
        summaryElement.setAttribute('aria-expanded', true);
        parentMenuElement && parentMenuElement.classList.add('submenu-open');
        const submenu = summaryElement.nextElementSibling;
        if (submenu) {
          submenu.classList.add('fade-in');

          !reducedMotion || reducedMotion.matches
            ? this.trapFocusAfterAnimation(submenu, summaryElement)
            : submenu.addEventListener('transitionend', () => this.trapFocusAfterAnimation(submenu, summaryElement), {
                once: true,
              });
        }
      }, 100);
    }
  }

  openMenuDrawer(summaryElement) {
    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });
    summaryElement.setAttribute('aria-expanded', true);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus = false) {
    if (event === undefined) return;

    this.mainDetailsToggle.classList.remove('menu-opening');
    this.mainDetailsToggle.querySelectorAll('details').forEach((details) => {
      details.removeAttribute('open');
      details.classList.remove('menu-opening');
    });
    this.mainDetailsToggle.querySelectorAll('.submenu-open').forEach((submenu) => {
      submenu.classList.remove('submenu-open');
    });
    document.body.classList.remove(`overflow-hidden-${this.dataset.breakpoint}`);
    removeTrapFocus(elementToFocus);
    this.closeAnimation(this.mainDetailsToggle);

    if (event instanceof KeyboardEvent) elementToFocus?.setAttribute('aria-expanded', false);
  }

  onFocusOut() {
    setTimeout(() => {
      if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement))
        this.closeMenuDrawer();
    });
  }

  onCloseButtonClick(event) {
    const detailsElement = event.currentTarget.closest('details');
    this.closeSubmenu(detailsElement);
  }

  closeSubmenu(detailsElement) {
    const parentMenuElement = detailsElement.closest('.submenu-open');
    parentMenuElement && parentMenuElement.classList.remove('submenu-open');
    detailsElement.classList.remove('menu-opening');
    detailsElement.querySelector('summary').setAttribute('aria-expanded', false);

    const submenu = detailsElement.querySelector('.menu-drawer__submenu');

    if (submenu) {
      submenu.classList.remove('fade-in');
    }

    removeTrapFocus(detailsElement.querySelector('summary'));
    this.closeAnimation(detailsElement);
  }

  trapFocusAfterAnimation(submenu, summaryElement) {
    submenu.removeEventListener('transitionend', () => this.trapFocusAfterAnimation(submenu, summaryElement));
    trapFocus(submenu, summaryElement.nextElementSibling.querySelector('button'));
  }

  closeAnimation(detailsElement) {
    let animationStart;

    const handleAnimation = (time) => {
      if (animationStart === undefined) {
        animationStart = time;
      }

      const elapsedTime = time - animationStart;

      if (elapsedTime < 400) {
        window.requestAnimationFrame(handleAnimation);
      } else {
        detailsElement.removeAttribute('open');
        if (detailsElement.closest('details[open]')) {
          trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
        }
      }
    };

    window.requestAnimationFrame(handleAnimation);
  }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
  constructor() {
    super();
  }

  openMenuDrawer(summaryElement) {
    this.header = this.header || document.querySelector('.section-header');
    this.borderOffset =
      this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
    document.documentElement.style.setProperty(
      '--header-bottom-position',
      `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
    );
    this.header.classList.add('menu-open');

    setTimeout(() => {
      this.mainDetailsToggle.classList.add('menu-opening');
    });

    summaryElement.setAttribute('aria-expanded', true);
    window.addEventListener('resize', this.onResize);
    trapFocus(this.mainDetailsToggle, summaryElement);
    document.body.classList.add(`overflow-hidden-${this.dataset.breakpoint}`);
  }

  closeMenuDrawer(event, elementToFocus) {
    if (!elementToFocus) return;
    super.closeMenuDrawer(event, elementToFocus);
    this.header.classList.remove('menu-open');
    window.removeEventListener('resize', this.onResize);
  }

  onResize = () => {
    this.header &&
      document.documentElement.style.setProperty(
        '--header-bottom-position',
        `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`
      );
    document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);
  };
}

customElements.define('header-drawer', HeaderDrawer);

class ModalDialog extends HTMLElement {
  constructor() {
    super();
    this.querySelector('[id^="ModalClose-"]').addEventListener('click', this.hide.bind(this, false));
    this.addEventListener('keyup', (event) => {
      if (event.code.toUpperCase() === 'ESCAPE') this.hide();
    });
    if (this.classList.contains('media-modal')) {
      this.addEventListener('pointerup', (event) => {
        if (event.pointerType === 'mouse' && !event.target.closest('deferred-media, product-model')) this.hide();
      });
    } else {
      this.addEventListener('click', (event) => {
        if (event.target === this) this.hide();
      });
    }
  }

  connectedCallback() {
    if (this.moved) return;
    this.moved = true;
    document.body.appendChild(this);
  }

  show(opener) {
    this.openedBy = opener;
    const popup = this.querySelector('.template-popup');
    document.body.classList.add('overflow-hidden');
    this.setAttribute('open', '');
    if (popup) popup.loadContent();
    trapFocus(this, this.querySelector('[role="dialog"]'));
    window.pauseAllMedia();
  }

  hide() {
    document.body.classList.remove('overflow-hidden');
    document.body.dispatchEvent(new CustomEvent('modalClosed'));
    this.removeAttribute('open');
    removeTrapFocus(this.openedBy);
    window.pauseAllMedia();
  }
}
customElements.define('modal-dialog', ModalDialog);

class ModalOpener extends HTMLElement {
  constructor() {
    super();

    const button = this.querySelector('button');

    if (!button) return;
    button.addEventListener('click', () => {
      const modal = document.querySelector(this.getAttribute('data-modal'));
      if (modal) modal.show(button);
    });
  }
}
customElements.define('modal-opener', ModalOpener);

class DeferredMedia extends HTMLElement {
  constructor() {
    super();
    const poster = this.querySelector('[id^="Deferred-Poster-"]');
    if (!poster) return;
    poster.addEventListener('click', this.loadContent.bind(this));
  }

  loadContent(focus = true, muted = false) {
    window.pauseAllMedia();
    if (!this.getAttribute('loaded')) {
      const content = document.createElement('div');
      // importNode (not cloneNode) so Safari creates the media element in this document, not the inert template one
      content.appendChild(document.importNode(this.querySelector('template').content.firstElementChild, true));

      this.setAttribute('loaded', true);
      const media = content.querySelector('video, model-viewer, iframe');
      // Browsers (iOS Safari especially) only allow autoplay when muted and inline
      if (muted && media.nodeName == 'VIDEO') {
        media.muted = true;
        media.setAttribute('muted', '');
        media.setAttribute('playsinline', '');
      }
      const deferredElement = this.appendChild(media);
      if (focus) deferredElement.focus();
      if (!muted && deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
        // force autoplay for safari
        deferredElement.play();
      }
    }
  }
}

customElements.define('deferred-media', DeferredMedia);

class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.enableSliderLooping = false;
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.pageTotalElement = this.querySelector('.slider-counter--total');
    this.prevButton = this.querySelector('button[name="previous"]');
    this.nextButton = this.querySelector('button[name="next"]');

    if (!this.slider || !this.nextButton) return;

    this.initPages();
    const resizeObserver = new ResizeObserver((entries) => this.initPages());
    resizeObserver.observe(this.slider);

    this.slider.addEventListener('scroll', this.update.bind(this));
    this.prevButton.addEventListener('click', this.onButtonClick.bind(this));
    this.nextButton.addEventListener('click', this.onButtonClick.bind(this));
  }

  initPages() {
    this.sliderItemsToShow = Array.from(this.sliderItems).filter((element) => element.clientWidth > 0);
    if (this.sliderItemsToShow.length < 2) return;
    this.sliderItemOffset = this.sliderItemsToShow[1].offsetLeft - this.sliderItemsToShow[0].offsetLeft;
    this.slidesPerPage = Math.floor(
      (this.slider.clientWidth - this.sliderItemsToShow[0].offsetLeft) / this.sliderItemOffset
    );
    this.totalPages = this.sliderItemsToShow.length - this.slidesPerPage + 1;
    this.update();
  }

  resetPages() {
    this.sliderItems = this.querySelectorAll('[id^="Slide-"]');
    this.initPages();
  }

  update() {
    // Temporarily prevents unneeded updates resulting from variant changes
    // This should be refactored as part of https://github.com/Shopify/dawn/issues/2057
    if (!this.slider || !this.nextButton) return;

    const previousPage = this.currentPage;
    this.currentPage = Math.round(this.slider.scrollLeft / this.sliderItemOffset) + 1;

    if (this.currentPageElement && this.pageTotalElement) {
      this.currentPageElement.textContent = this.currentPage;
      this.pageTotalElement.textContent = this.totalPages;
    }

    if (this.currentPage != previousPage) {
      this.dispatchEvent(
        new CustomEvent('slideChanged', {
          detail: {
            currentPage: this.currentPage,
            currentElement: this.sliderItemsToShow[this.currentPage - 1],
          },
        })
      );
    }

    if (this.enableSliderLooping) return;

    if (this.isSlideVisible(this.sliderItemsToShow[0]) && this.slider.scrollLeft === 0) {
      this.prevButton.setAttribute('disabled', 'disabled');
    } else {
      this.prevButton.removeAttribute('disabled');
    }

    if (this.isSlideVisible(this.sliderItemsToShow[this.sliderItemsToShow.length - 1])) {
      this.nextButton.setAttribute('disabled', 'disabled');
    } else {
      this.nextButton.removeAttribute('disabled');
    }
  }

  isSlideVisible(element, offset = 0) {
    const lastVisibleSlide = this.slider.clientWidth + this.slider.scrollLeft - offset;
    return element.offsetLeft + element.clientWidth <= lastVisibleSlide && element.offsetLeft >= this.slider.scrollLeft;
  }

  onButtonClick(event) {
    event.preventDefault();
    const step = event.currentTarget.dataset.step || 1;
    this.slideScrollPosition =
      event.currentTarget.name === 'next'
        ? this.slider.scrollLeft + step * this.sliderItemOffset
        : this.slider.scrollLeft - step * this.sliderItemOffset;
    this.setSlidePosition(this.slideScrollPosition);
  }

  setSlidePosition(position) {
    this.slider.scrollTo({
      left: position,
    });
  }
}

customElements.define('slider-component', SliderComponent);

class SlideshowComponent extends SliderComponent {
  constructor() {
    super();
    this.sliderControlWrapper = this.querySelector('.slider-buttons');
    this.enableSliderLooping = true;

    if (!this.sliderControlWrapper) return;

    this.sliderFirstItemNode = this.slider.querySelector('.slideshow__slide');
    if (this.sliderItemsToShow.length > 0) this.currentPage = 1;

    this.announcementBarSlider = this.querySelector('.announcement-bar-slider');
    // Value below should match --duration-announcement-bar CSS value
    this.announcerBarAnimationDelay = this.announcementBarSlider ? 250 : 0;

    this.sliderControlLinksArray = Array.from(this.sliderControlWrapper.querySelectorAll('.slider-counter__link'));
    this.sliderControlLinksArray.forEach((link) => link.addEventListener('click', this.linkToSlide.bind(this)));
    this.slider.addEventListener('scroll', this.setSlideVisibility.bind(this));
    this.setSlideVisibility();

    if (this.announcementBarSlider) {
      this.announcementBarArrowButtonWasClicked = false;

      this.reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.reducedMotion.addEventListener('change', () => {
        if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
      });

      [this.prevButton, this.nextButton].forEach((button) => {
        button.addEventListener(
          'click',
          () => {
            this.announcementBarArrowButtonWasClicked = true;
          },
          { once: true }
        );
      });
    }

    if (this.slider.getAttribute('data-autoplay') === 'true') this.setAutoPlay();
  }

  setAutoPlay() {
    this.autoplaySpeed = this.slider.dataset.speed * 1000;
    this.addEventListener('mouseover', this.focusInHandling.bind(this));
    this.addEventListener('mouseleave', this.focusOutHandling.bind(this));
    this.addEventListener('focusin', this.focusInHandling.bind(this));
    this.addEventListener('focusout', this.focusOutHandling.bind(this));

    if (this.querySelector('.slideshow__autoplay')) {
      this.sliderAutoplayButton = this.querySelector('.slideshow__autoplay');
      this.sliderAutoplayButton.addEventListener('click', this.autoPlayToggle.bind(this));
      this.autoplayButtonIsSetToPlay = true;
      this.play();
    } else {
      this.reducedMotion.matches || this.announcementBarArrowButtonWasClicked ? this.pause() : this.play();
    }
  }

  onButtonClick(event) {
    super.onButtonClick(event);
    this.wasClicked = true;

    const isFirstSlide = this.currentPage === 1;
    const isLastSlide = this.currentPage === this.sliderItemsToShow.length;

    if (!isFirstSlide && !isLastSlide) {
      this.applyAnimationToAnnouncementBar(event.currentTarget.name);
      return;
    }

    if (isFirstSlide && event.currentTarget.name === 'previous') {
      this.slideScrollPosition =
        this.slider.scrollLeft + this.sliderFirstItemNode.clientWidth * this.sliderItemsToShow.length;
    } else if (isLastSlide && event.currentTarget.name === 'next') {
      this.slideScrollPosition = 0;
    }

    this.setSlidePosition(this.slideScrollPosition);

    this.applyAnimationToAnnouncementBar(event.currentTarget.name);
  }

  setSlidePosition(position) {
    if (this.setPositionTimeout) clearTimeout(this.setPositionTimeout);
    this.setPositionTimeout = setTimeout(() => {
      this.slider.scrollTo({
        left: position,
      });
    }, this.announcerBarAnimationDelay);
  }

  update() {
    super.update();
    this.sliderControlButtons = this.querySelectorAll('.slider-counter__link');
    this.prevButton.removeAttribute('disabled');

    if (!this.sliderControlButtons.length) return;

    this.sliderControlButtons.forEach((link) => {
      link.classList.remove('slider-counter__link--active');
      link.removeAttribute('aria-current');
    });
    this.sliderControlButtons[this.currentPage - 1].classList.add('slider-counter__link--active');
    this.sliderControlButtons[this.currentPage - 1].setAttribute('aria-current', true);
  }

  autoPlayToggle() {
    this.togglePlayButtonState(this.autoplayButtonIsSetToPlay);
    this.autoplayButtonIsSetToPlay ? this.pause() : this.play();
    this.autoplayButtonIsSetToPlay = !this.autoplayButtonIsSetToPlay;
  }

  focusOutHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (!this.autoplayButtonIsSetToPlay || focusedOnAutoplayButton) return;
      this.play();
    } else if (!this.reducedMotion.matches && !this.announcementBarArrowButtonWasClicked) {
      this.play();
    }
  }

  focusInHandling(event) {
    if (this.sliderAutoplayButton) {
      const focusedOnAutoplayButton =
        event.target === this.sliderAutoplayButton || this.sliderAutoplayButton.contains(event.target);
      if (focusedOnAutoplayButton && this.autoplayButtonIsSetToPlay) {
        this.play();
      } else if (this.autoplayButtonIsSetToPlay) {
        this.pause();
      }
    } else if (this.announcementBarSlider.contains(event.target)) {
      this.pause();
    }
  }

  play() {
    this.slider.setAttribute('aria-live', 'off');
    clearInterval(this.autoplay);
    this.autoplay = setInterval(this.autoRotateSlides.bind(this), this.autoplaySpeed);
  }

  pause() {
    this.slider.setAttribute('aria-live', 'polite');
    clearInterval(this.autoplay);
  }

  togglePlayButtonState(pauseAutoplay) {
    if (pauseAutoplay) {
      this.sliderAutoplayButton.classList.add('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.playSlideshow);
    } else {
      this.sliderAutoplayButton.classList.remove('slideshow__autoplay--paused');
      this.sliderAutoplayButton.setAttribute('aria-label', window.accessibilityStrings.pauseSlideshow);
    }
  }

  autoRotateSlides() {
    const slideScrollPosition =
      this.currentPage === this.sliderItems.length ? 0 : this.slider.scrollLeft + this.sliderItemOffset;

    this.setSlidePosition(slideScrollPosition);
    this.applyAnimationToAnnouncementBar();
  }

  setSlideVisibility(event) {
    this.sliderItemsToShow.forEach((item, index) => {
      const linkElements = item.querySelectorAll('a');
      if (index === this.currentPage - 1) {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.removeAttribute('tabindex');
          });
        item.setAttribute('aria-hidden', 'false');
        item.removeAttribute('tabindex');
      } else {
        if (linkElements.length)
          linkElements.forEach((button) => {
            button.setAttribute('tabindex', '-1');
          });
        item.setAttribute('aria-hidden', 'true');
        item.setAttribute('tabindex', '-1');
      }
    });
    this.wasClicked = false;
  }

  applyAnimationToAnnouncementBar(button = 'next') {
    if (!this.announcementBarSlider) return;

    const itemsCount = this.sliderItems.length;
    const increment = button === 'next' ? 1 : -1;

    const currentIndex = this.currentPage - 1;
    let nextIndex = (currentIndex + increment) % itemsCount;
    nextIndex = nextIndex === -1 ? itemsCount - 1 : nextIndex;

    const nextSlide = this.sliderItems[nextIndex];
    const currentSlide = this.sliderItems[currentIndex];

    const animationClassIn = 'announcement-bar-slider--fade-in';
    const animationClassOut = 'announcement-bar-slider--fade-out';

    const isFirstSlide = currentIndex === 0;
    const isLastSlide = currentIndex === itemsCount - 1;

    const shouldMoveNext = (button === 'next' && !isLastSlide) || (button === 'previous' && isFirstSlide);
    const direction = shouldMoveNext ? 'next' : 'previous';

    currentSlide.classList.add(`${animationClassOut}-${direction}`);
    nextSlide.classList.add(`${animationClassIn}-${direction}`);

    setTimeout(() => {
      currentSlide.classList.remove(`${animationClassOut}-${direction}`);
      nextSlide.classList.remove(`${animationClassIn}-${direction}`);
    }, this.announcerBarAnimationDelay * 2);
  }

  linkToSlide(event) {
    event.preventDefault();
    const slideScrollPosition =
      this.slider.scrollLeft +
      this.sliderFirstItemNode.clientWidth *
        (this.sliderControlLinksArray.indexOf(event.currentTarget) + 1 - this.currentPage);
    this.slider.scrollTo({
      left: slideScrollPosition,
    });
  }
}

customElements.define('slideshow-component', SlideshowComponent);

class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('change', this.onVariantChange);
  }

  onVariantChange(event) {
    this.updateOptions();
    this.updateMasterId();
    this.updateSelectedSwatchValue(event);
    this.toggleAddButton(true, '', false);
    this.updatePickupAvailability();
    this.removeErrorMessage();
    this.updateVariantStatuses();
    this.updateGifting();
    this.updatePersonalisation();

    if (!this.currentVariant) {
      this.toggleAddButton(true, '', true);
      this.setUnavailable();
    } else {
      this.updateURL();
      this.updateVariantInput();
      this.renderProductInfo();
      this.updateShareUrl();
    }
  }

  updateOptions() {
    this.options = Array.from(this.querySelectorAll('select, fieldset'), (element) => {
      if (element.tagName === 'SELECT') {
        return element.value;
      }
      if (element.tagName === 'FIELDSET') {
        return Array.from(element.querySelectorAll('input')).find((radio) => radio.checked)?.value;
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      return !variant.options
        .map((option, index) => {
          return this.options[index] === option;
        })
        .includes(false);
    });
  }

  updateSelectedSwatchValue({ target }) {
    const { name, value, tagName } = target;

    if (tagName === 'SELECT' && target.selectedOptions.length) {
      const swatchValue = target.selectedOptions[0].dataset.optionSwatchValue;
      const selectedDropdownSwatchValue = this.querySelector(`[data-selected-dropdown-swatch="${name}"] > .swatch`);
      if (!selectedDropdownSwatchValue) return;
      if (swatchValue) {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', swatchValue);
        selectedDropdownSwatchValue.classList.remove('swatch--unavailable');
      } else {
        selectedDropdownSwatchValue.style.setProperty('--swatch--background', 'unset');
        selectedDropdownSwatchValue.classList.add('swatch--unavailable');
      }

      selectedDropdownSwatchValue.style.setProperty(
        '--swatch-focal-point',
        target.selectedOptions[0].dataset.optionSwatchFocalPoint || 'unset'
      );
    } else if (tagName === 'INPUT' && target.type === 'radio') {
      const selectedSwatchValue = this.querySelector(`[data-selected-swatch-value="${name}"]`);
      if (selectedSwatchValue) selectedSwatchValue.innerHTML = value;
    }
  }

  updateURL() {
    if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
    window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton || !shareButton.updateUrl) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
    const productForms = document.querySelectorAll(
      `#product-form-${this.dataset.section},
       #product-form-quickadd-${this.dataset.section},
       #product-form-installment-${this.dataset.section},
       #product-form-installment-quickadd-${this.dataset.section}`
    );
    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  updateVariantStatuses() {
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(':checked').value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll('.product-form__input')];
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;
      const optionInputs = [...option.querySelectorAll('input[type="radio"], option')];
      const previousOptionSelected = inputWrappers[index - 1].querySelector(':checked').value;
      const availableOptionInputsValue = selectedOptionOneVariants
        .filter((variant) => variant.available && variant[`option${index}`] === previousOptionSelected)
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  updateGifting() {
    const mainVariantIdInput = document.getElementById('main__variantId');

    if (mainVariantIdInput) {
      mainVariantIdInput.value = this.currentVariant.id;
    }
  }

  setInputAvailability(elementList, availableValuesList) {
    elementList.forEach((element) => {
      const value = element.getAttribute('value');
      const availableElement = availableValuesList.includes(value);

      if (element.tagName === 'INPUT') {
        element.classList.toggle('disabled', !availableElement);
      } else if (element.tagName === 'OPTION') {
        element.innerText = availableElement
          ? value
          : window.variantStrings.unavailable_with_option.replace('[value]', value);
      }
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector('pickup-availability');
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute('available');
      pickUpAvailability.innerHTML = '';
    }
  }

  updatePersonalisation() {
    // Scope to this product instance: the personalisation IDs aren't section-scoped, so a page can
    // hold several (PDP, quick-add modal, cart lines). A document-wide query could match the cart's
    // opener, which has no confirm box, and throw.
    const root = this.closest('product-info') || this.closest('section') || document;
    const personalisationButton = root.querySelector('#PersonalisationDrawerOpener');
    if (!personalisationButton) return;

    const personalisationConfirmBox = root.querySelector('#PersonalisationConfirmBox');
    const personalisationConfirmBoxButtons = personalisationConfirmBox
      ? personalisationConfirmBox.querySelectorAll('.personalisation-confirm__action')
      : [];

    if (this.currentVariant && this.currentVariant.available) {
      personalisationButton.removeAttribute('disabled');
      personalisationConfirmBox?.classList.remove('disabled');
      personalisationConfirmBoxButtons.forEach((button) => {
        button.disabled = false;
      });
    } else {
      personalisationButton.setAttribute('disabled', 'disabled');
      personalisationConfirmBox?.classList.add('disabled');
      personalisationConfirmBoxButtons.forEach((button) => {
        button.disabled = true;
      });
    }

    if (this.currentVariant) {
      personalisationButton.dataset.variantId = this.currentVariant.id;
    }
  }

  removeErrorMessage() {
    const section = this.closest('section');
    if (!section) return;

    const productForm = section.querySelector('product-form');
    if (productForm) productForm.handleErrorMessage();
  }

  updateMedia(html) {
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const mediaGallerySource = document.querySelector(`[id^="MediaGallery-${this.dataset.section}"] ul`);
    const mediaGalleryDestination = html.querySelector(`[id^="MediaGallery-${sectionId}"] ul`);

    const refreshSourceData = () => {
      const mediaGallerySourceItems = Array.from(mediaGallerySource.querySelectorAll('li[data-media-id]'));
      const sourceSet = new Set(mediaGallerySourceItems.map((item) => item.dataset.mediaId));
      const sourceMap = new Map(mediaGallerySourceItems.map((item, index) => [item.dataset.mediaId, { item, index }]));
      return [mediaGallerySourceItems, sourceSet, sourceMap];
    };

    if (mediaGallerySource && mediaGalleryDestination) {
      let [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
      const mediaGalleryDestinationItems = Array.from(mediaGalleryDestination.querySelectorAll('li[data-media-id]'));
      const destinationSet = new Set(mediaGalleryDestinationItems.map(({ dataset }) => dataset.mediaId));
      let shouldRefresh = false;

      // add items from new data not present in DOM
      for (let i = mediaGalleryDestinationItems.length - 1; i >= 0; i--) {
        if (!sourceSet.has(mediaGalleryDestinationItems[i].dataset.mediaId)) {
          mediaGallerySource.prepend(mediaGalleryDestinationItems[i]);
          shouldRefresh = true;
        }
      }

      // remove items from DOM not present in new data
      for (let i = 0; i < mediaGallerySourceItems.length; i++) {
        if (!destinationSet.has(mediaGallerySourceItems[i].dataset.mediaId)) {
          mediaGallerySourceItems[i].remove();
          shouldRefresh = true;
        }
      }

      // refresh
      if (shouldRefresh) [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();

      // if media galleries don't match, sort to match new data order
      mediaGalleryDestinationItems.forEach((destinationItem, destinationIndex) => {
        const sourceData = sourceMap.get(destinationItem.dataset.mediaId);

        if (sourceData && sourceData.index !== destinationIndex) {
          mediaGallerySource.insertBefore(
            sourceData.item,
            mediaGallerySource.querySelector(`li:nth-of-type(${destinationIndex + 1})`)
          );

          // refresh source now that it has been modified
          [mediaGallerySourceItems, sourceSet, sourceMap] = refreshSourceData();
        }
      });
    }

    if (this.currentVariant.featured_media) {
      document
        .querySelector(`[id^="MediaGallery-${this.dataset.section}"]`)
        ?.setActiveMedia?.(`${this.dataset.section}-${this.currentVariant.featured_media.id}`);
    }

    // update media modal
    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newModalContent = html.querySelector(`product-modal`);
    if (modalContent && newModalContent) modalContent.innerHTML = newModalContent.innerHTML;
  }

  renderProductInfo() {
    if (!this._debouncedFetchProductInfo) {
      this._debouncedFetchProductInfo = debounce(this.fetchProductInfo.bind(this), ON_VARIANT_CHANGE_DEBOUNCE_TIMER);
    }
    this._debouncedFetchProductInfo();
  }

  fetchProductInfo() {
    // selection may have become unavailable during the debounce window
    if (!this.currentVariant) return;

    const requestedVariantId = this.currentVariant.id;
    const sectionId = this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section;
    const urlSeparator = this.dataset.url.includes('?') ? '&' : '?';

    // abort any in-flight request superseded by this selection
    this._variantFetchController?.abort();
    this._variantFetchController = new AbortController();

    fetch(
      `${this.dataset.url}${urlSeparator}variant=${requestedVariantId}&section_id=${sectionId}`,
      { signal: this._variantFetchController.signal }
    )
      .then((response) => response.text())
      .then((responseText) => {
        // prevent unnecessary ui changes from abandoned selections
        if (this.currentVariant.id !== requestedVariantId) return;

        const html = new DOMParser().parseFromString(responseText, 'text/html');
        const destination = document.getElementById(`price-${this.dataset.section}`);
        const source = html.getElementById(
          `price-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuSource = html.getElementById(
          `Sku-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const skuDestination = document.getElementById(`Sku-${this.dataset.section}`);
        const inventorySource = html.getElementById(
          `Inventory-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );
        const inventoryDestination = document.getElementById(`Inventory-${this.dataset.section}`);

        const volumePricingSource = html.getElementById(
          `Volume-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        this.updateMedia(html);

        const pricePerItemDestination = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
        const pricePerItemSource = html.getElementById(
          `Price-Per-Item-${this.dataset.originalSection ? this.dataset.originalSection : this.dataset.section}`
        );

        const volumePricingDestination = document.getElementById(`Volume-${this.dataset.section}`);
        const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);
        const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);

        if (volumeNote) volumeNote.classList.remove('hidden');
        if (volumePricingDestination) volumePricingDestination.classList.remove('hidden');
        if (qtyRules) qtyRules.classList.remove('hidden');

        if (source && destination) destination.innerHTML = source.innerHTML;
       if (inventoryDestination) {
         inventoryDestination.innerHTML = inventorySource?.innerHTML || '';
         inventoryDestination.classList.toggle('hidden', !inventorySource || inventorySource.innerText === '');
       }
        if (skuSource && skuDestination) {
          skuDestination.innerHTML = skuSource.innerHTML;
          skuDestination.classList.toggle('hidden', skuSource.classList.contains('hidden'));
        }

        if (volumePricingSource && volumePricingDestination) {
          volumePricingDestination.innerHTML = volumePricingSource.innerHTML;
        }

        if (pricePerItemSource && pricePerItemDestination) {
          pricePerItemDestination.innerHTML = pricePerItemSource.innerHTML;
          pricePerItemDestination.classList.toggle('hidden', pricePerItemSource.classList.contains('hidden'));
        }

        const price = document.getElementById(`price-${this.dataset.section}`);

        if (price) price.classList.remove('hidden');


        const addButtonUpdated = html.getElementById(`ProductSubmitButton-${sectionId}`);
        this.toggleAddButton(
          addButtonUpdated ? addButtonUpdated.hasAttribute('disabled') : true,
          window.variantStrings.soldOut
        );

        const giftOptionButton = document.getElementById(`gifting-button-${sectionId}`);
        if (giftOptionButton) {
          const isAddButtonDisabled = addButtonUpdated.hasAttribute('disabled');

          if (isAddButtonDisabled) {
            giftOptionButton.setAttribute('disabled', 'disabled');
          } else {
            giftOptionButton.removeAttribute('disabled');
          }
        }

        publish(PUB_SUB_EVENTS.variantChange, {
          data: {
            sectionId,
            html,
            variant: this.currentVariant,
          },
        });
      })
      .catch((error) => {
        if (error.name === 'AbortError') return;
        console.error(error);
      });
  }

  toggleAddButton(disable = true, text, modifyClass = true) {
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    if (!productForm) return;

    const addButton = productForm.querySelector('[name="add"]');
    const addButtonText = productForm.querySelector('[name="add"] > span');
    const skipCtaUpdate = addButton.classList.contains('quick-add__submit--using-quick-shop');
    const section = this.dataset.originalSection || this.dataset.section;
    const variantPriceSelector = `.variantPrice-${section}`;
    const productInfoContainer = this.dataset.section.includes('quickadd-template')
      ? productForm.closest('.product__info-container')
      : null;

    const variantPrice = (productInfoContainer || document).querySelector(variantPriceSelector);
    const defaultText = window.variantStrings.addToCart;
    let textContent = defaultText;
    if (!skipCtaUpdate) {
      if (variantPrice && variantPrice.innerText) {
        let finalPrice = variantPrice.innerText;

        const personalisationId = document.querySelector('#ProductPropertiesInitials');
        const hasGiftBoxInput = document.querySelector('#hasgiftboxId');

        const isPersonalised = personalisationId && personalisationId.value !== '';
        const hasGiftBox = hasGiftBoxInput && Boolean(!hasGiftBoxInput.hasAttribute('disabled'));

        const personalisedPrice = (productInfoContainer || document).querySelector(
          `${variantPriceSelector}-personalised`
        );
        const giftBoxPrice = (productInfoContainer || document).querySelector(`${variantPriceSelector}-gift-box`);
        const personalisedGiftBoxPrice = (productInfoContainer || document).querySelector(
          `${variantPriceSelector}-personalised-gift-box`
        );

        const giftingDrawer = document.querySelector(`gifting-drawer[data-section="${section}"]`);
        const selectedGiftBox =
          giftingDrawer?.querySelector('.gift-box-checkbox:checked') ||
          document.querySelector('.gift-box-checkbox:checked');
        const selectedGiftBoxPriceCents = Number(selectedGiftBox?.dataset?.productPriceCents || 0);
        const persistedGiftBoxPriceCents = Number(
          document.querySelector('#gift-box-price')?.dataset?.priceCents || 0
        );
        const activeGiftBoxPriceCents =
          selectedGiftBoxPriceCents || persistedGiftBoxPriceCents;
        const variantPriceCents = Number(variantPrice.dataset.priceCents || 0);
        const personalisedPriceCents = Number(personalisedPrice?.dataset?.priceCents || 0);

        if (hasGiftBox) {
          const basePriceCents = isPersonalised ? personalisedPriceCents : variantPriceCents;
          if (
            activeGiftBoxPriceCents > 0 &&
            basePriceCents > 0 &&
            window.Shopify?.locale &&
            window.Shopify?.currency?.active
          ) {
            finalPrice = new Intl.NumberFormat(window.Shopify.locale, {
              style: 'currency',
              currency: window.Shopify.currency.active,
              currencyDisplay: 'narrowSymbol',
            }).format((basePriceCents + activeGiftBoxPriceCents) / 100);
          } else if (isPersonalised && personalisedGiftBoxPrice && personalisedGiftBoxPrice.innerText) {
            finalPrice = personalisedGiftBoxPrice.innerText;
          } else if (!isPersonalised && giftBoxPrice && giftBoxPrice.innerText) {
            finalPrice = giftBoxPrice.innerText;
          } else if (isPersonalised && personalisedPrice && personalisedPrice.innerText) {
            finalPrice = personalisedPrice.innerText;
          }
        } else if (isPersonalised && personalisedPrice && personalisedPrice.innerText) {
          finalPrice = personalisedPrice.innerText;
        }

        textContent = `${finalPrice} - ${defaultText}`;
      }
    }

    if (skipCtaUpdate) {
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
      } else {
        addButton.removeAttribute('disabled');
      }
    } else {
      if (disable) {
        addButton.setAttribute('disabled', 'disabled');
        if (text) addButtonText.textContent = text;
      } else {
        addButton.removeAttribute('disabled');
        addButtonText.textContent = textContent;
      }
    }
    if (!modifyClass) return;
  }

  setUnavailable() {
    const button = document.getElementById(`product-form-${this.dataset.section}`);
    const addButton = button.querySelector('[name="add"]');
    const addButtonText = button.querySelector('[name="add"] > span');
    const price = document.getElementById(`price-${this.dataset.section}`);
    const inventory = document.getElementById(`Inventory-${this.dataset.section}`);
    const sku = document.getElementById(`Sku-${this.dataset.section}`);
    const pricePerItem = document.getElementById(`Price-Per-Item-${this.dataset.section}`);
    const volumeNote = document.getElementById(`Volume-Note-${this.dataset.section}`);
    const volumeTable = document.getElementById(`Volume-${this.dataset.section}`);
    const qtyRules = document.getElementById(`Quantity-Rules-${this.dataset.section}`);

    if (!addButton) return;
    if (!addButton.hasAttribute('data-add-to-box-mode')) addButtonText.textContent = window.variantStrings.unavailable;
    if (price) price.classList.add('hidden');
    if (inventory) inventory.classList.add('hidden');
    if (sku) sku.classList.add('hidden');
    if (pricePerItem) pricePerItem.classList.add('hidden');
    if (volumeNote) volumeNote.classList.add('hidden');
    if (volumeTable) volumeTable.classList.add('hidden');
    if (qtyRules) qtyRules.classList.add('hidden');
  }

  getVariantData() {
    this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}

customElements.define('variant-selects', VariantSelects);

class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    const handleIntersection = (entries, observer) => {
      if (!entries[0].isIntersecting) return;
      observer.unobserve(this);

      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');

          if (recommendations && recommendations.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
          }

          if (!this.querySelector('slideshow-component') && this.classList.contains('complementary-products')) {
            this.remove();
          }

          if (html.querySelector('.grid__item')) {
            this.classList.add('product-recommendations--loaded');
          }
        })
        .catch((e) => {
          console.error(e);
        });
    };

    new IntersectionObserver(handleIntersection.bind(this), { rootMargin: '0px 0px 400px 0px' }).observe(this);
  }
}

customElements.define('product-recommendations', ProductRecommendations);

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class VideoPlayer extends HTMLElement {
  constructor() {
    super();
    this.state = 'loading';
    this.videoElement = this.querySelector('.video-js');

    if (!this.videoElement) {
      return;
    }

    this.playElement = this.querySelector('[js-video-player="play"]');
    this.pauseElement = this.querySelector('[js-video-player="pause"]');

    /**
     * Event listener.
     */
    this.playElement.addEventListener('click', this.playVideo.bind(this));
    this.pauseElement.addEventListener('click', this.pauseVideo.bind(this));
    this.videoElement.addEventListener('ended', this.videoEnded.bind(this));

    /**
     * Intersection Observer. Playback (and, for preload="none" videos, the
     * file download) starts when the video scrolls into view.
     */
    const startObserving = () => {
      this.observer = new IntersectionObserver(this.handleIntersection.bind(this), {
        threshold: 0.1,
      });
      this.observer.observe(this.videoElement);
    };

    // Poster-first hero on mobile: the video sits in the initial viewport, so
    // observing immediately would call play() -> download the MP4 right away
    // and block the LCP. Defer until after window load so the preloaded poster
    // is the LCP; then play as normal. Desktop and all other videos are
    // unaffected and start observing immediately.
    const deferMobilePlay =
      this.hasAttribute('data-defer-mobile-play') &&
      window.matchMedia('(max-width: 749px)').matches;

    if (deferMobilePlay && document.readyState !== 'complete') {
      window.addEventListener('load', () => requestAnimationFrame(startObserving), { once: true });
    } else {
      startObserving();
    }
  }

  handleIntersection(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.playVideo();
      } else {
        this.pauseVideo();
      }
    });
  }

  /**
   * Play video.
   */
  async playVideo() {
    try {
      await this.videoElement.play();
      this.state = 'playing';
      this.updateButtonState();
    } catch (error) {
      reportError('Failed to play video', error);
    }
  }

  /**
   * Pause video.
   */
  async pauseVideo() {
    try {
      await this.videoElement.pause();
      this.state = 'paused';
      this.updateButtonState();
    } catch (error) {
      reportError('Failed to play video', error);
    }
  }

  /**
   * Update button state.
   */
  updateButtonState() {
    if (this.state === 'playing') {
      this.playElement.classList.add('is-active');
      this.pauseElement.classList.remove('is-active');
    }

    if (this.state === 'paused') {
      this.playElement.classList.remove('is-active');
      this.pauseElement.classList.add('is-active');
    }
  }

  /**
   * Video ended.
   */
  videoEnded() {
    this.videoElement.currentTime = 0;
    this.pauseVideo();
  }
}

customElements.define('video-player', VideoPlayer);

class OverflowProgressBar extends HTMLElement {
  constructor() {
    super();
    this.isDragging = false;
    this.startX = 0;
    this.scrollLeftStart = 0;
    this.updateProgressBar = this.updateProgressBar.bind(this);
    this.startDrag = this.startDrag.bind(this);
    this.onDrag = this.onDrag.bind(this);
    this.stopDrag = this.stopDrag.bind(this);
  }

  connectedCallback() {
    this.contentElement = this.querySelector('[data-overflow-container]');
    this.progressBar = document.createElement('div');
    this.progressBar.classList.add('progress-bar');
    this.appendChild(this.progressBar);

    this.updateProgressBar();
    this.contentElement.addEventListener('scroll', this.updateProgressBar);
    window.addEventListener('resize', this.updateProgressBar);

    this.contentElement.addEventListener('mousedown', this.startDrag);
    window.addEventListener('mousemove', this.onDrag);
    window.addEventListener('mouseup', this.stopDrag);
  }

  disconnectedCallback() {
    this.contentElement.removeEventListener('scroll', this.updateProgressBar);
    window.removeEventListener('resize', this.updateProgressBar);
    this.contentElement.removeEventListener('mousedown', this.startDrag);
    window.removeEventListener('mousemove', this.onDrag);
    window.removeEventListener('mouseup', this.stopDrag);
  }

  updateProgressBar() {
    const { scrollLeft, scrollWidth, clientWidth } = this.contentElement;
    const scrollPercentage = (scrollLeft / (scrollWidth - clientWidth)) * 100;
    const visiblePercentage = (clientWidth / scrollWidth) * 100;

    if (this.getAttribute('mode') === 'scroll') {
      const scrollbarWidth = (clientWidth / scrollWidth) * 100;
      const scrollbarLeft = (scrollLeft / scrollWidth) * 100;

      this.progressBar.style.width = `${scrollbarWidth}%`;
      this.progressBar.style.left = `${scrollbarLeft}%`;
    } else {
      this.progressBar.style.width = `${Math.max(visiblePercentage, scrollPercentage)}%`;
    }

    if (scrollWidth > clientWidth) {
      this.progressBar.style.display = 'block';
      this.contentElement.classList.add('overflowing');
    } else {
      this.progressBar.style.display = 'none';
      this.contentElement.classList.remove('overflowing');
    }
  }

  startDrag(e) {
    this.isDragging = true;
    this.startX = e.pageX;
    this.scrollLeftStart = this.contentElement.scrollLeft;
    e.preventDefault();
  }

  onDrag(e) {
    if (this.isDragging) {
      const x = e.pageX;
      // Sensitivity
      const walk = (x - this.startX) * 2;
      this.contentElement.scrollLeft = this.scrollLeftStart - walk;
    }
  }

  stopDrag() {
    this.isDragging = false;
  }
}

customElements.define('overflow-progress-bar', OverflowProgressBar);

// Prevent interactive elements inside card anchors from bubbling and causing unwanted navigation
document.addEventListener('DOMContentLoaded', function() {
  // Target product card anchors more specifically
  const cardAnchors = document.querySelectorAll('a[id^="CardLink-"]');
  
  cardAnchors.forEach(anchor => {
    if (anchor.hasAttribute('data-interactive-handled')) return;
    
    anchor.setAttribute('data-interactive-handled', 'true');
    anchor.addEventListener('click', function(event) {
      // Check if the clicked element is an interactive element  
      const clickedElement = event.target;
      const modalToggle = clickedElement.closest('.quick-add-modal__toggle');
      const interactiveElement = clickedElement.closest('button, input, select, textarea, [role="button"], .quick-add-opener, quick-add-opener, .card__wishlist-add, .colour-swatches__swatch, .colour-swatch-button');
      
      // Always prevent navigation for modal close buttons
      if (modalToggle) {
        event.preventDefault();
        event.stopPropagation();
        return;
      }
      
      // Only prevent navigation for other interactive elements if NOT inside modal content
      if (interactiveElement && !clickedElement.closest('.quick-add-modal') && !clickedElement.closest('product-form') && !clickedElement.closest('form')) {
        event.preventDefault();
        event.stopPropagation();
      }
    });
  });
});

// High-performance colour swatch functionality using event delegation
document.addEventListener('DOMContentLoaded', function() {
  // Use event delegation - single listener for entire document
  let originalImageCache = new WeakMap(); // Use WeakMap for automatic garbage collection
  
  // Single click handler for all swatches - use capture phase to run first
  document.addEventListener('click', function(e) {
    // Ensure e.target exists and has the closest method
    if (!e.target || typeof e.target.closest !== 'function') return;
    
    const swatchButton = e.target.closest('.colour-swatch-button');
    if (!swatchButton) return;
    
    // Stop the event immediately to prevent card link handling
    e.preventDefault();
    e.stopImmediatePropagation();
    
    const productHandle = swatchButton.getAttribute('data-product-handle');
    if (productHandle) {
      window.location.href = `/products/${productHandle}`;
    }
  }, true); // Use capture phase to run before other handlers
  
  // Single mouseenter handler for all swatches
  document.addEventListener('mouseenter', function(e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    
    const swatchButton = e.target.closest('.colour-swatch-button');
    if (!swatchButton) return;
    
    const cardWrapper = swatchButton.closest('.card-wrapper, .product-card-wrapper');
    if (!cardWrapper) return;
    
    // Cache images only when needed
    if (!originalImageCache.has(cardWrapper)) {
      const mainImages = cardWrapper.querySelectorAll('.card__media img');
      const imageData = Array.from(mainImages).map(img => ({
        element: img,
        originalSrc: img.src,
        originalSrcset: img.srcset || ''
      }));
      originalImageCache.set(cardWrapper, imageData);
    }
    
    const imageData = originalImageCache.get(cardWrapper);
    const featuredImage = swatchButton.getAttribute('data-featured-image');
    const hoverImage = swatchButton.getAttribute('data-hover-image');
    
    if (featuredImage && imageData[0]) {
      imageData[0].element.src = featuredImage;
      imageData[0].element.removeAttribute('srcset');
    }
    if (hoverImage && imageData[1]) {
      imageData[1].element.src = hoverImage;
      imageData[1].element.removeAttribute('srcset');
    }
  }, true); // Use capture phase for better performance
  
  // Single mouseleave handler for all swatches
  document.addEventListener('mouseleave', function(e) {
    if (!e.target || typeof e.target.closest !== 'function') return;
    
    const swatchButton = e.target.closest('.colour-swatch-button');
    if (!swatchButton) return;
    
    const cardWrapper = swatchButton.closest('.card-wrapper, .product-card-wrapper');
    if (!cardWrapper) return;
    
    const imageData = originalImageCache.get(cardWrapper);
    if (!imageData) return;
    
    // Restore original images
    imageData.forEach(({ element, originalSrc, originalSrcset }) => {
      element.src = originalSrc;
      if (originalSrcset) {
        element.srcset = originalSrcset;
      }
    });
     }, true); // Use capture phase for better performance
});

// Colour swatch scrolling arrows functionality
document.addEventListener('DOMContentLoaded', function() {
  const swatchContainers = document.querySelectorAll('.colour-swatches__container');
  
  swatchContainers.forEach(container => {
    const swatchList = container.querySelector('.colour-swatches');
    const prevButton = container.querySelector('.colour-swatches__arrow--prev .colour-swatches__arrow-button');
    const nextButton = container.querySelector('.colour-swatches__arrow--next .colour-swatches__arrow-button');
    
    if (!swatchList || !prevButton || !nextButton) return;
    
    // Check if scrolling is needed
    const checkScrollButtons = () => {
      const { scrollLeft, scrollWidth, clientWidth } = swatchList;
      
      // Show/hide arrows based on scroll position
      if (scrollWidth <= clientWidth) {
        // No overflow, hide arrows by removing scrollable class
        container.classList.remove('colour-swatches__container--scrollable');
      } else {
        // Show arrows by adding scrollable class
        container.classList.add('colour-swatches__container--scrollable');
        
        // Enable/disable based on scroll position
        prevButton.classList.toggle('colour-swatches__arrow--disabled', scrollLeft <= 0);
        // Apply the disabled class to the parent arrow container as well
        if (prevButton.parentElement) {
          prevButton.parentElement.classList.toggle('colour-swatches__arrow--disabled', scrollLeft <= 0);
        }
        nextButton.classList.toggle('colour-swatches__arrow--disabled', scrollLeft >= scrollWidth - clientWidth);
        if (nextButton.parentElement) {
          nextButton.parentElement.classList.toggle('colour-swatches__arrow--disabled', scrollLeft >= scrollWidth - clientWidth);
        }
      }
    };
    
    // Scroll amount (width of approximately 3 swatches)
    const scrollAmount = 3 * (1.8 * 16 + 8); // 1.8rem + gap in pixels
    
    // Previous button click
    prevButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      swatchList.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    
    // Next button click
    nextButton.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      swatchList.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
    
    // Update button states on scroll
    swatchList.addEventListener('scroll', checkScrollButtons);
    
    // Initial check
    checkScrollButtons();
    
    // Check on resize
    window.addEventListener('resize', checkScrollButtons);
  });
});

// ========= Klaviyo Star Rating Helper =========
// Extract numeric rating from `aria-label` (e.g. "3 stars, 2 ratings") and
// add it as a `data-rating` attribute so it can be displayed via CSS.
// This runs once on DOMContentLoaded and also watches for dynamically
// inserted rating widgets (Klaviyo injects them asynchronously).

document.addEventListener('DOMContentLoaded', function () {
  // Utility: extract rating number (first numeric value before 'stars')
  const extractRating = (ariaLabel = '') => {
    const match = ariaLabel.match(/(\d+(?:\.\d+)?)\s*stars/i);
    return match ? match[1] : null;
  };

  const setRatingOnBadge = (badgeElem, rating) => {
    if (!badgeElem) return;

    // Determine the widget (top-level element) to annotate/hide
    const widgetElem = badgeElem.classList.contains('klaviyo-star-rating-widget')
      ? badgeElem
      : badgeElem.closest('.klaviyo-star-rating-widget') || badgeElem;

    const num = parseFloat(rating);

    // Hide widget if rating missing, not a number, or zero; otherwise ensure it's visible
    if (!rating || isNaN(num) || num === 0) {
      widgetElem.style.display = 'none';
      return;
    }

    // Ensure widget is visible in case it was previously hidden
    if (widgetElem.style.display === 'none') {
      widgetElem.style.display = '';
    }

    // Round to 1 decimal place
    const rounded = Math.round(num * 10) / 10;

    // Avoid unnecessary updates
    if (widgetElem.dataset.rating === String(rounded)) return;

    widgetElem.setAttribute('data-rating', rounded);
  };

  const processElement = (elem) => {
    if (!(elem instanceof HTMLElement)) return;

    // Find the widget or badge wrapper that we will annotate / hide
    const badgeWrapper = elem.closest('.klaviyo-star-rating-widget, .kl_reviews__stars_badge');
    if (!badgeWrapper) return;

    // Prefer aria-label on the wrapper, otherwise search inside
    const ariaSource = badgeWrapper.hasAttribute('aria-label')
      ? badgeWrapper
      : badgeWrapper.querySelector('[aria-label*="stars"]');

    const ariaLabel = ariaSource ? ariaSource.getAttribute('aria-label') : '';
    const rating = extractRating(ariaLabel); // may be null

    // Always call setter so it can decide to hide when rating is 0/null
    setRatingOnBadge(badgeWrapper, rating);
  };

  // Initial scan
  document.querySelectorAll('.klaviyo-star-rating-widget, .kl_reviews__stars_badge').forEach(processElement);

  // ---- Lazy hydration of card star-rating widgets ----
  // Card placeholders (snippets/card-product.liquid) render WITHOUT the
  // `klaviyo-star-rating-widget` class so Klaviyo's embed skips them on page
  // load. When a card scrolls near the viewport the placeholder is REPLACED
  // with a clone carrying the real class — a childList insertion, because
  // Klaviyo's embed re-scans added nodes but is not guaranteed to notice an
  // in-place class toggle. PDP / featured-product / product-details-modal
  // widgets keep the real class in Liquid and are untouched.
  const hydrateLazyStarRating = (widget) => {
    const hydrated = widget.cloneNode(true);
    hydrated.classList.remove('card__klaviyo-star-rating-widget--lazy');
    hydrated.classList.add('klaviyo-star-rating-widget');
    hydrated.removeAttribute('data-lazy-rating-observed');
    widget.replaceWith(hydrated);
  };

  const lazyStarRatingObserver =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          (entries, intersectionObserver) => {
            entries.forEach((entry) => {
              if (!entry.isIntersecting) return;
              intersectionObserver.unobserve(entry.target);
              hydrateLazyStarRating(entry.target);
            });
          },
          { rootMargin: '200px 0px' }
        )
      : null;

  const wireLazyStarRatings = (root) => {
    const scope = root instanceof HTMLElement ? root : document;
    const widgets = [];

    if (scope !== document && scope.matches('.card__klaviyo-star-rating-widget--lazy')) widgets.push(scope);
    scope.querySelectorAll('.card__klaviyo-star-rating-widget--lazy').forEach((widget) => widgets.push(widget));

    widgets.forEach((widget) => {
      if (widget.hasAttribute('data-lazy-rating-observed')) return;
      widget.setAttribute('data-lazy-rating-observed', 'true');

      if (lazyStarRatingObserver) {
        lazyStarRatingObserver.observe(widget);
      } else {
        hydrateLazyStarRating(widget);
      }
    });
  };

  wireLazyStarRatings(document);
  // ---- End lazy hydration ----

  // Observe future inserts & aria-label changes
  const observer = new MutationObserver((mutations) => {
    mutations.forEach((mutation) => {
      if (mutation.type === 'attributes' && mutation.attributeName === 'aria-label') {
        processElement(mutation.target);
      }

      if (mutation.type === 'childList') {
        mutation.addedNodes.forEach((node) => {
          processElement(node);
          if (node instanceof HTMLElement) wireLazyStarRatings(node);
        });
      }
    });
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true,
    attributes: true,
    attributeFilter: ['aria-label']
  });
});

// ========= End Klaviyo Star Rating Helper =========
